import CommissionAndPayout from "../../views/AffiliatePortal/CommissionAndPayout/CommissionAndPayout";
import Dashboard from "../../views/AffiliatePortal/Dashboard/Dashboard";
import Profile from "../../views/AffiliatePortal/Profile/Profile";
import PromotionalMaterials from "../../views/AffiliatePortal/PromotionalMaterials/PromotionalMaterials";
import ReportsAnalytics from "../../views/AffiliatePortal/ReportsAnalytics/ReportsAnalytics";
import ServicesAndSupport from "../../views/AffiliatePortal/Services&Support/ServicesAndSupport";

const affiliateRoutes = [
  {
    path: "/dashboard",
    element: <Dashboard />,
    meta: {
      layout: "vertical",
    },
  },
  {
    path: "/reports",
    element: <ReportsAnalytics />,
    meta: {
      layout: "vertical",
    },
  },
  {
    path: "/promotionalmaterials",
    element: <PromotionalMaterials />,
    meta: {
      layout: "vertical",
    },
  },
  {
    path: "/profile",
    element: <Profile />,
    meta: {
      layout: "vertical",
    },
  },
  {
    path: "/servicesandsupport",
    element: <ServicesAndSupport />,
    meta: {
      layout: "vertical",
    },
  },
  {
    path: "/commissionandpayout",
    element: <CommissionAndPayout/>,
    meta: {
      layout: 'vertical',
    }
  },
];

export default affiliateRoutes;